import {DocumentBase} from './DocumentBase';
import {ViewBase} from './ViewBase';
import {defaultViewSelector, ViewSelector} from './ViewSelector';

export enum FlagName {
  MID_REPORTING_OVERVIEW = 'midReportingOverview',
  RESIDUALS_OVERRIDE_AUTO_UPDATE = 'residualsOverrideAutoUpdate',
  VAR_SHEET_WIZARD_CRM = 'varSheetWizardCrm',
  VAR_SHEET_WIZARD_PORTAL = 'varSheetWizardPortal',
  LOCK_ASSIGNMENTS_DATE_CHECK_DISABLED = 'lockAssignmentsDateCheckDisabled',
}

export type FeatureFlag = DocumentBase & {
  flag: FlagName;
  description?: string;
  enabled?: boolean;
};

export type FeatureFlagView = ViewBase<FeatureFlag>;

export const selectFeatureFlagView: ViewSelector<FeatureFlagView, FeatureFlag> = snapshot => {
  const featureFlag: FeatureFlagView = {
    ...defaultViewSelector(snapshot),
  };
  return featureFlag;
};
